export default "__VITE_ASSET__DgO8w15v__"